import React, { useEffect } from "react";
import { Spin } from "antd";
import { useParams, useSearchParams } from "react-router-dom";
import { resolveNewFrontendHref } from "../../../app/navigation/new-frontend-href";

/**
 * 旧详情路径改写：收藏和预警以外的 /vendor-crm/:编号?tab= 必须落到新详情的查询参数。
 * 只改导航归属会让这些链接进新前端 /:编号，静态导出下 404。
 */
export default function VendorCrmDetailRedirect() {
    const { id } = useParams();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const params = new URLSearchParams();
        const reserved = ["new", "alerts", "detail"];
        if (!id || reserved.includes(id)) {
            const suffix = id ? `/${id}` : "";
            window.location.replace(resolveNewFrontendHref(`/contract-management/vendor-crm${suffix}`));
            return;
        }
        params.set("id", id);
        const tab = searchParams.get("tab");
        if (tab && tab !== "profile") {
            params.set("tab", tab);
        }
        const query = params.toString();
        const path = `/contract-management/vendor-crm/detail${query ? `?${query}` : ""}`;
        window.location.replace(resolveNewFrontendHref(path));
    }, [id, searchParams]);

    return (
        <div className="page-container">
            <div style={{ textAlign: "center", padding: 48 }}>
                <Spin />
                <div style={{ marginTop: 12 }}>正在打开新的供应商详情…</div>
            </div>
        </div>
    );
}
